import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import 'react-loading-skeleton/dist/skeleton.css'
// Redux Imports
import {useDispatch, useSelector} from "react-redux";
import {getDemographic} from "../../../slices/veloxity/profile/DemographicReducer";
import {getInApp} from "../../../slices/veloxity/profile/InAppReducer";
import {getSalesPrediction} from "../../../slices/veloxity/profile/SalesPredictionReducer";
import {getInterest} from "../../../slices/veloxity/profile/InterestReducer";
import {getProfileComment} from "../../../slices/veloxity/profile/ProfileCommentReducer";


// custom components
import {Button, Col, Container, Row} from "reactstrap";

//Small Images
import smallImage9 from "../../../assets/images/small/img-9.jpg";
//Segmentasyon
import ProfileCard from "./ProfileCard";
import DemographicCard from "./DemographicCard";
import InterestsCard from "./InterestsCard";
import InAppConsumptionCard from "./InAppConsumptionCard";
import SalesConsumptionPredictionCard from "./SalesConsumptionPredictionCard";

import productIcon from "../../../assets/images/product.png";
import CustomerGrowthModal from "../../../components/modal/CustomerGrowthModal";
import SalesGrowthModal from "../../../components/modal/SalesGrowthModal";

import showComingSoonAlert from "../../../components/custom/comingSoonAlert";

import BreadCrumb from "../../../components/common/BreadCrumb";


import './Profile.css';

const ProfileDetail = ({selectedClientId, onBack}) => {
    document.title = "Veloxity Dashboard";

    // Redux Dispatch
    const dispatch = useDispatch();


    //const { clientDeviceIds } = useSelector((state) => state.VeloxityDevices);
    const {state} = useLocation();
    const [isLoading, setIsLoading] = useState(true);

    const {
        osName,
        deviceModel,
        persona,
        personaName,
      
        generation,
        gender,
        country,
        city,
        purchasingPower,
    } = useSelector((state) => state.demographic);

    const {
        mostUsedServiceName,
        mostUsedServiceCount,
        mostViewServiceName,
        mostViewServiceCount,
        lastActivity,
    } = useSelector((state) => state.inApp);

    const {
        predictions
    } = useSelector((state) => state.salesPrediction);


    const {
        interests
    } = useSelector((state) => state.interests);


    const {
        profileComment
    } = useSelector((state) => state.profileComment);


    const [isEmpty, setIsEmpty] = useState(true);

    // custom States
    const [selectedOption, setSelectedOption] = useState({});
    const [options, setOptions] = useState([]);
    // const [selectedOption, setSelectedOption] = useState({
    // });

    const [col1, setCol1] = useState(false);
    const t_col1 = () => {
        setCol1(!col1);
    };


    // İlk modal için state değişkeni
    const [modal1, setModal1] = useState(false);
    // İkinci modal için state değişkeni
    const [modal2, setModal2] = useState(false);

    // İlk modal'ı açmak için kullanılacak fonksiyon
    const toggleModal1 = () => {
        setModal1(!modal1);
    };

    // İkinci modal'ı açmak için kullanılacak fonksiyon
    const toggleModal2 = () => {
        setModal2(!modal2);
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([
                    dispatch(getDemographic({clientId: selectedClientId})),
                    dispatch(getInterest({clientId: selectedClientId})),
                    dispatch(getInApp({clientId: selectedClientId})),
                    dispatch(getProfileComment({clientId: selectedClientId})),
                ]);
            } catch (error) {
                console.error("Hata:", error);
            }
            setIsLoading(false);
        };

        setIsLoading(true);
        fetchData();
    }, [selectedClientId, dispatch]);


    useEffect(() => {

        const fetchData = async () => {

            await dispatch(getSalesPrediction({clientId: selectedClientId}));
        };

        fetchData()

    }, []);

    useEffect(() => {
        setOptions([
            {
                value: "C963592F-033B-40AD-8B5F-0CD2772DD4AB",
                label: "C963592F-033B-40AD-8B5F-0CD2772DD4AB",
            },
            {
                value: "C77F2219-E84C-4EE7-8C89-057A8271E869",
                label: "C77F2219-E84C-4EE7-8C89-057A8271E869",
            },

            {
                value: "0023FFE3-2DB2-478D-A469-C267468FAD82",
                label: "0023FFE3-2DB2-478D-A469-C267468FAD82",
            },
            {
                value: "001cf67fd1825ef2",
                label: "001cf67fd1825ef2",
            },

            {
                value: "001D3ED2-36E5-4FC9-AC91-C104192D70FD",
                label: "001D3ED2-36E5-4FC9-AC91-C104192D70FD",
            },

            {
                value: "01e560c012f45a50",
                label: "01e560c012f45a50",
            }
        ]);

        const list = document.querySelectorAll(".team-list");
        const buttonGroups = document.querySelectorAll(".filter-button");
        for (let i = 0; i < buttonGroups.length; i++) {
            buttonGroups[i].addEventListener("click", onButtonGroupClick);
        }

        function onButtonGroupClick(event) {
            if (
                event.target.id === "list-view-button" ||
                event.target.parentElement.id === "list-view-button"
            ) {
                document.getElementById("list-view-button").classList.add("active");
                document.getElementById("grid-view-button").classList.remove("active");
                list.forEach(function (el) {
                    el.classList.add("list-view-filter");
                    el.classList.remove("grid-view-filter");
                });
            } else {
                document.getElementById("grid-view-button").classList.add("active");
                document.getElementById("list-view-button").classList.remove("active");
                list.forEach(function (el) {
                    el.classList.remove("list-view-filter");
                    el.classList.add("grid-view-filter");
                });
            }
        }
    }, [selectedOption]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                <BreadCrumb title="User Detail" pageTitle="Customer Analytics" />
                    {(<Col>

                            <Row style={{marginBottom: "20px"}}>

                                <Col className="d-flex justify-content-between align-items-center">
                                    <Button className="back-button" onClick={onBack}>
                                        <i className="ri-arrow-left-line ri-xl fs-19"></i>Back
                                    </Button>
                                    <div className="d-flex gap-2">
                                        <Button style={{width: "190px"}} color="primary" /*onClick={toggleModal1}*/ onClick={showComingSoonAlert}>
                                            Increase Your Sales
                                        </Button>
                                        <Button style={{width: "190px"}} color="primary" /*</div>onClick={toggleModal2}*/ onClick={showComingSoonAlert}>
                                            Acquire More Customers
                                        </Button>
                                    </div>
                                </Col>


                                {/* İlk modal */}
                                <SalesGrowthModal isOpen={modal1} toggle={toggleModal1}/>

                                {/* İkinci modal */}
                                <CustomerGrowthModal isOpen={modal2} toggle={toggleModal2}/>

                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <Row className="team-list grid-view-filter">
                                        <Col lg={12}>
                                            <ProfileCard
                                                smallImage={smallImage9}
                                                lastActivity={lastActivity}
                                                ProfileType={personaName}
                                                profileComment={profileComment}
                                                osName={osName}
                                                deviceModel={deviceModel}
                                                clientDeviceId={selectedClientId}

                                            />

                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col>
                                            <InAppConsumptionCard
                                                mostUsedServiceName={mostUsedServiceName}
                                                mostUsedServiceCount={mostUsedServiceCount}
                                                mostViewServiceCount={mostViewServiceCount}
                                                mostViewServiceName={mostViewServiceName}
                                            />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col lg={5}>
                                    <Row>
                                        <Col>
                                            <DemographicCard generation={generation} gender={gender} country={country}
                                                             city={city} purchasingPower={purchasingPower}/>

                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col style={{}}>
                                            <SalesConsumptionPredictionCard predictions={predictions}
                                                                            productIcon={productIcon}/>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col lg={3}>
                                    <InterestsCard interests={interests}/>
                                </Col>
                            </Row>
                        </Col>
                    )}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ProfileDetail;